module.exports = __webpack_public_path__ + "static/media/delete.353b49c7.svg";